import { NavLink, Outlet, useParams } from 'react-router-dom';
import { useDepartment } from '../../../utils/api-hooks/department.hook';
import { Spin } from 'antd';

function Link({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        isActive
          ? 'font-bold border-0 border-solid border-t-0 border-x-0 border-b p-1 px-2'
          : 'p-1 px-2 border-0 hover:border-solid hover:border-t-0 hover:border-x-0 hover:border-b text-black'
      }
    >
      {children}
    </NavLink>
  );
}

export default function DepartmentContainer() {
  const { id } = useParams();
  const { data: { data } = {}, isLoading } = useDepartment({ id: id! });
  const { name } = data || {};

  return (
    <div className="flex flex-col items-stretch h-full overflow-hidden">
      <span className="text-2xl">{name}</span>
      <nav className="flex py-2 gap-1">
        <Link to={`employees`}>部門成員</Link>
      </nav>
      <div className="flex-grow pt-4 pb-12 overflow-auto">
        <Spin spinning={isLoading}>
          <Outlet />
        </Spin>
      </div>
    </div>
  );
}
